import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { RolesEnum } from '../enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class CustomerRoleGuard  {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authenticationService.getAuthorizedUser().Role === RolesEnum.CustomerRole || RolesEnum.UserRole || RolesEnum.AdminRole) {
      return true;
    } else {
      this.router.navigate(['/authentication']);
      return false;
    }
  }
}
